import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "@app/shared/shared.module";

import { ControlModule } from "../../control.module";

import { AdvEffControlOverviewComponent } from "./control-overview/adv-eff-control-overview.component";
import { WizardComponent } from "./control-overview/wizard/adv-eff-wizard.component";

import { AdvEffOverviewComponent } from "./overview/adv-eff-overview.component";

import { AdvEffHistoryDataService } from "./control-overview/adv-eff-history-data.service";
import { OverviewDataService } from "./control-overview/shared/adv-eff-overview-data.service";
import { TestPeriodDataService } from "./control-overview/testperiod-manager/adv-eff-testperiod-data.service";
import { AuditSamplerDataService } from "./control-overview/audit-sampler/adv-eff-audit-sampler-data.service";
import { AdvEffDataService, AdvEffWorkflowDataService } from "./shared/services";

import { EffDetailNewModule } from "./detail-new/eff-detail-new.module";

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        ControlModule,
        EffDetailNewModule.forRoot(),
        AdvEffControlOverviewComponent,
        WizardComponent,
        AdvEffOverviewComponent,
    ],
})
export class AdvancedTestingModule {
    static forRoot(): ModuleWithProviders<AdvancedTestingModule> {
        return {
            ngModule: AdvancedTestingModule,
            providers: [
                AdvEffDataService,
                AdvEffWorkflowDataService,
                OverviewDataService,
                TestPeriodDataService,
                AuditSamplerDataService,
                AdvEffHistoryDataService,
            ],
        };
    }
}
